// Third-party scripts with no first-party consumers, loaded on the first interaction
// so they stay out of the initial page load: Hotjar and the LiveConnect ad tag.
import onFirstInteraction from '@/scripts/utils/first-interaction.js';

const HOTJAR = {hjid: 5028389, hjsv: 6};
const LIVECONNECT_SRC = 'https://b-code.liadm.com/b-00b3.min.js';

function appendScript(src) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
}

function loadHotjar() {
    // Vendor stub: queue `arguments` as-is, the shape Hotjar's script replays.
    window.hj = window.hj || function () {
        (window.hj.q = window.hj.q || []).push(arguments);
    };
    window._hjSettings = HOTJAR;
    appendScript(`https://static.hotjar.com/c/hotjar-${HOTJAR.hjid}.js?sv=${HOTJAR.hjsv}`);
}

onFirstInteraction(() => {
    loadHotjar();
    appendScript(LIVECONNECT_SRC);
});
